
    import './styles.scoped.css';
    export default {
  "info": "awsui_info_1fhsi_6k3bb_5"
};
  